<script>
    import { forgotUserPassword } from '/public/services/users/users';
    import { fade } from 'svelte/transition';

    let processed = false;

    let email = null;

    function processForgottenPassword(e) {
        e.preventDefault();

        processed = false;

        forgotUserPassword({
            email: email
        }).then(res => {
            if (res.success) {
                processed = true;
            }
        });

    }
</script>

<div class="card">
    <div class="card-header">
        Forgot your password?
    </div>
    <div class="card-body">

        {#if processed === true}

            <div class="alert alert-success mb-3 clearfix" in:fade>
                <h4 class='float-start me-2'>
                    <span class="fas fa-info-circle"></span>
                </h4>
                A password reset email will be sent to: {email}, if we found your account.
            </div>

        {/if}

        <form on:submit={processForgottenPassword}>
            <div class="row mb-3">
                <label class="col-sm-3 col-form-label" for="email">
                    Email
                </label>
                <div class="col-sm-9">
                    <input 
                        type="email" 
                        class="form-control" 
                        required 
                        bind:value={email} 
                        placeholder="What is your email address?"
                         class:is-invalid='{email == null}'
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-9 offset-sm-3">
                    <button type="submit" class="btn btn-primary">
                        <span class="fas fa-lock-open"></span> Retrieve your Password
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
